import { useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { EngineeringTableForm, EngineeringTableFormType } from './EngineeringTableForm'
import { createEngineeringTableRow } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useNavigate } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Engineering Table',
    path: '/system/vertical-support-engineering'
  },
  {
    label: 'Add',
    isCurrentPage: true
  }
]

export const AddEngineeringTableRow = () => {
  const navigate = useNavigate()
  const { createToast } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleAdd = async (form) => {
    setIsSubmitting(true)
    try {
      await createEngineeringTableRow(form)
      createToast('success', 'Engineering table row created')
      navigate('/system/vertical-support-engineering')
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response?.data?.error || err.response?.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Add Engineering Table Row</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Row Data</Heading>
          </CardHeader>
          <CardBody p={8}>
            <EngineeringTableForm
              type={EngineeringTableFormType.Add}
              onSubmit={handleAdd}
              isSubmitting={isSubmitting}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
